export enum EntityEnum {
  dw_Accounts = 1,
  dw_Groups = 2,
  dw_Sites = 3,
  dw_Buildings = 4,
  dw_Loads = 5,
  dw_Channels = 6,
}

export enum UtilityTypeEnum {
  None = 0,
  Electricity = 1,
  Water = 2,
  Gas = 3,
  Production = 4,
  Heat = 5,
  Steam = 6,
  Weather = 7,
  Enviromental = 8,
  GHGEmmissions = 9,
  Other = 10,
  Solar = 11,
}

export enum SourceTypeEnum {
  Unknown = 0,
  Account = 1,
  AccountAddress = 2,
  Contact = 3,
  Site = 4,
  Building = 5,
  Feed = 6,
  Load = 7,
  Channel = 8,
  Dashboard = 9,
  Report = 10,
  Project = 11,
  FeedConfig = 12,
  FeedConfigChannel = 13,
  ContactRole = 14,
  MLNotifications = 15,
  ChannelRule = 16,
  ChannelMapping = 17,
  Group = 18,
  GroupsSites = 19,
  BulkInsertLoadChannels = 20,
  BulkInsertFeedConfigChannels = 21,
  AccountSubscriptionModule = 22,
}

export enum StatusEnum {
  Active = 1,
  Inactive = 2,
  Deleted = 3,
  Unvalidated = 4,
}

export enum AccountStatusEnum {
  Active = 1,
  Inactive = 2,
}

export enum AccountSubscriptionStatusEnum {
  Active = 0,
  Suspended = 1,
  Closed = 2,
  Created = 3,
  Cancelling = 4,
}

export enum SubscriptionModuleEnum {
  Unknown = 0,
  CollectPdfIngestion = 1,
  CarbonCalculation = 2,
}

export enum ContactStatusEnum {
  Active = 1,
  Inactive = 2,
  Deleted = 3,
}

export enum ContactRoleStatusEnum {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
  Deleted = 3,
  Invited = 4,
}

export enum ProjectPriorityEnum {
  Low = 0,
  Medium = 1,
  High = 2,
}

export enum ProjectStatusEnum {
  Unknown = 0,
  New = 1,
  InProgress = 2,
  Complete = 3,
}

export enum JobStatusEnum {
  Pending = 0,
  Queued = 1,
  Processing = 2,
  Completed = 3,
  Failed = 4,
  IngestionQueue = 5,
}

export enum DashboardStatusEnum {
  Active = 1,
  Deleted = 2,
  Pending = 3,
}

export enum SummationTypeEnum {
  Unknown = 0,
  SUM = 1,
  AVG = 2,
}

export enum ValueTypeEnum {
  Unknown = 0,
  ActualForInterval = 1,
  Instantaneous = 2,
  Cumulative = 3,
}

export enum NatureTypeEnum {
  Unknown = 0,
  Consumption = 1,
  Mlr = 2,
  Losses = 3,
  WasteWater = 4,
  Financial = 5,
  Other = 10,
}

export enum ChannelTypeEnum {
  Actual = 1,
  Calculated = 2,
  MLR = 3,
}

export enum ContactTypeEnum {
  Client = 1,
  Esp = 2,
}

export enum RoleEnum {
  User = 1,
  Admin = 2,
  Reviewer = 3,
  Contributor = 4,
  Editor = 5,
}

export enum NabersRatingEnum {
  None = 0,
  Tenant = 1,
  Basebuild = 2,
}

export enum ConsumptionJobTypeEnum {
  Unknown = 0,
  EICT = 1,
  IoT = 2,
  AIUT = 3,
  Clariti = 4,
  eGuage = 5,
}

export enum ConsumptionJobReadingTypeEnum {
  Unknown = 0,
  A = 1,
  E = 2,
}

export enum ConsumptionJobStatusEnum {
  Pending = 0,
  Queued = 1,
  Processing = 2,
  Completed = 3,
  Failed = 4,
}

export enum AddressTypeEnum {
  Unknown = 0,
  Physical = 1,
  Billing = 2,
}

export enum BaselineModeEnum {
  Unknown = 0,
  Baseline = 1,
  MLR = 2,
}

export enum ReportTypeEnum {
  Unknown = 0,
  Operational = 1,
  Sustainability = 2,
}

export enum WeatherReadingTypeEnum {
  Recorded = 0,
  Forecast = 1,
}

export enum ChannelsValueTypeEnum {
  Unknown = 0,
  ActualForInterval = 1,
  Instantaneous = 2,
  Cumulative = 2,
}

export enum FeedsConfigStatusEnum {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
  Deleted = 3,
}

export enum FeedsRegisterTypeEnum {
  R4Integer = 0,
  R4Floating = 1,
  R3Integer = 2,
  R3Floating = 3,
  R1Boolean = 4,
  R0Boolean = 5,
  R3Hex = 6,
  R4Hex = 7,
}

export enum NotificationFrequencyEnum {
  None = 0,
  Monthly = 1,
}

export enum SubscriptionStatusEnum {
  Active = 0,
  Suspended = 1,
  Closed = 2,
  Created = 3,
  Cancelling = 4,
}

export enum NotificationsDateRangeEnum {
  Today = 'Today',
  Past24Hours = 'Past 24 hours',
  Past48Hours = 'Past 48 hours',
  Past1Week = 'Past 1 week',
  Past2Weeks = 'Past 2 weeks',
  Past4Weeks = 'Past 4 weeks',
  PastYear = 'Past year',
  Custom = 'Custom',
}

export enum ApiOutcomeEnum {
  Error = 0,
  Unauthorised = 1,
  Successful = 2,
}

export enum SortEnum {
  None = 0,
  Ascending = 1,
  Descending = 2,
}

export enum IntervalEnum {
  None = 0,
  Yearly = 1,
  Monthly = 2,
  Weekly = 3,
  Daily = 4,
  Hourly = 5,
  HalfHourly = 6,
  QuarterHourly = 7,
  Minute = 8,
  LooseFrequency = 9,
  TenMinutes = 10,
  FiveMinutes = 11,
}

export enum NotificationsStatusEnum {
  Pending = 0,
  Disqualified = 1,
  Qualified = 2,
  Ignored = 3,
  Investigating = 4,
  WorkInProgress = 5,
  Resolved = 6,
  QualifiedNotify = 7,
  QualifiedSuppressed = 8,
  BraveGenInvestigating = 9,
}

export enum EndiannessEnum {
  Big = 0,
  MidBig = 1,
  MidLittle = 2,
  Little = 3,
}
